"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuery = exports.ANALYTICS_REPORT_ROWS_LIMIT = exports.SPLIT_BY_APP_BUNDLE_ROWS_LIMIT = void 0;
const dbSchema_1 = require("../../reporterDb/dbSchema");
const dbTableCampaign_1 = require("../../reporterDb/dbTableCampaign");
const query_1 = require("../../reporterDb/query");
const measuresAsColumns_1 = require("../measuresAsColumns");
const columnTypes_1 = require("../measuresAsColumns/columnTypes");
const measuresInterDependency_1 = require("../measuresInterDependency");
const queryMapping_1 = require("./queryMapping");
exports.SPLIT_BY_APP_BUNDLE_ROWS_LIMIT = 500;
const VALUE_ALIAS_PREFIX = "hasValue";
exports.ANALYTICS_REPORT_ROWS_LIMIT = 10000;
const measureToQueryExpr = (roasEventsInCampaign, roasEventsInCampaignsMap, isMultiCampaign) => (ev) => {
    let measureSelect;
    const eventName = ev.eventId || ev.id;
    if (dbTableCampaign_1.BOR_MEASURES[eventName]) {
        measureSelect = isMultiCampaign
            ? (0, dbTableCampaign_1.getBorMeasureMultiCampsExpr)({
                eventName,
                roasEventsInCampaignsMap,
            })
            : (0, dbTableCampaign_1.getBorMeasureExpr)({
                eventName,
                roasEventsInCampaign,
            });
    }
    else {
        measureSelect = queryMapping_1.ANALYTICS_QUERY_MAP.SELECT[ev.id];
    }
    return measureSelect;
};
const customMeasureToQueryExpr = (m, onException) => {
    const { id, columnType } = m;
    if (columnType === columnTypes_1.ColumnTypes.AppMeasureV2 || columnType === columnTypes_1.ColumnTypes.AppMeasureSumV2) {
        const { eventId } = m;
        return queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.appMeasure({
            eventName: eventId,
            kind: columnType === columnTypes_1.ColumnTypes.AppMeasureSumV2 ? dbTableCampaign_1.CustomEventKind.sum : dbTableCampaign_1.CustomEventKind.count,
        });
    }
    else if (columnType === columnTypes_1.ColumnTypes.AppMeasureCPAV2) {
        const { eventId } = m;
        return queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.appMeasureCPA(eventId);
    }
    const { value, kind, whereValues } = m;
    const eventName = value || id.replace("_CPA", "");
    if (columnType === columnTypes_1.ColumnTypes.AppMeasure ||
        columnType === columnTypes_1.ColumnTypes.CohortedAppMeasure) {
        return queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.appMeasure({
            eventName,
            kind,
        });
    }
    else if (columnType === columnTypes_1.ColumnTypes.AppMeasureCPA ||
        columnType === columnTypes_1.ColumnTypes.CohortedAppMeasureCPA) {
        // no need to pass kind here - we always want spend/count of events
        // for Cost Per Action metricts
        return queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.appMeasureCPA(eventName);
    }
    else if (columnType === columnTypes_1.ColumnTypes.DimensionAsMeasure ||
        columnType === columnTypes_1.ColumnTypes.DimensionAsMeasureCPA ||
        columnType === columnTypes_1.ColumnTypes.DimensionAsMeasurePCPA) {
        if (eventName === dbTableCampaign_1.DimensionIds.CONVERSION_VALUE) {
            return (whereValues === null || whereValues === void 0 ? void 0 : whereValues.length) ? queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.skanCV(columnType, whereValues) : query_1.DUMMY_EXPRESSION;
        }
        return queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.dimensionAsMeasure({
            columnType,
            eventName,
            kind,
            whereValues,
        });
    }
    onException === null || onException === void 0 ? void 0 : onException(`No query expression for appMeasures, id:${id}, columnType:${columnType}, kind:${kind}, value:${value}`);
    return query_1.DUMMY_EXPRESSION;
};
const cohortMeasureToQueryExpr = (roasEventsInCampaign, roasEventsInCampaignsMap, isMultiCampaign) => (cm) => {
    let measureSelect;
    if (dbTableCampaign_1.BOR_MEASURES[cm.eventId] && cm.columnType === columnTypes_1.ColumnTypes.Cohorted) {
        measureSelect = isMultiCampaign
            ? (0, dbTableCampaign_1.getCohortedBorMeasureMultiCampExpr)({
                eventName: cm.eventId,
                roasEventsInCampaignsMap,
                cohort: cm.cohort,
            })
            : (0, dbTableCampaign_1.getCohortedBorMeasureExpr)({
                eventName: cm.eventId,
                roasEventsInCampaign,
                cohort: cm.cohort,
            });
    }
    else {
        measureSelect = queryMapping_1.ANALYTICS_QUERY_MAP.SELECT.cohorted({
            eventName: cm.eventId,
            cohort: cm.cohort,
            columnType: cm.columnType,
            eventKind: cm.eventKind,
        });
    }
    return measureSelect;
};
const getMeasuresSelectQuery = ({ roasEventsInCampaign, roasEventsInCampaignsMap, orderedColumns, isMultiCampaign, hiddenColumns = {}, withValueAliases, onException, }) => {
    var _a;
    const selectExps = [];
    const valueAliases = new Set();
    const pushSelect = (expr, isSummable) => {
        var _a;
        if (!withValueAliases || !isSummable || !expr || typeof expr !== "object") {
            selectExps.push(expr);
            return;
        }
        const alias = (_a = expr.alias) !== null && _a !== void 0 ? _a : `${VALUE_ALIAS_PREFIX}${selectExps.length}`;
        valueAliases.add(alias);
        selectExps.push(Object.assign(Object.assign({}, expr), { alias }));
    };
    const { columnsWithDeps } = (0, measuresInterDependency_1.getVisibleColumnsWithDependencies)(orderedColumns, hiddenColumns);
    for (let column of columnsWithDeps !== null && columnsWithDeps !== void 0 ? columnsWithDeps : []) {
        if ((0, measuresAsColumns_1.isCohortableColumnType)(column.columnType) || (0, measuresAsColumns_1.isCohortedAppMeasureV2)(column)) {
            const normalizedEvent = (0, measuresAsColumns_1.isCohortedAppMeasureV2)(column) ? {
                eventId: column.cohortedEventId,
                eventKind: column.columnType === columnTypes_1.ColumnTypes.AppMeasureSumV2 ? dbTableCampaign_1.CustomEventKind.sum : dbTableCampaign_1.CustomEventKind.count,
            } :
                //deprecated column type:
                (0, measuresAsColumns_1.isAppMeasureColumnType)(column.columnType)
                    ? {
                        eventId: column.value,
                        eventKind: column.kind,
                    }
                    : {
                        eventId: column.eventId,
                        eventKind: column.kind,
                    };
            const cohortedResultExprs = (_a = column.cohorts) === null || _a === void 0 ? void 0 : _a.map((cohort) => {
                return cohortMeasureToQueryExpr(roasEventsInCampaign, roasEventsInCampaignsMap, isMultiCampaign)({
                    columnId: column.id,
                    eventId: normalizedEvent.eventId,
                    eventKind: normalizedEvent.eventKind,
                    columnType: column.columnType,
                    cohort,
                    eventLabel: "", //not used in query
                });
            });
            if (cohortedResultExprs === null || cohortedResultExprs === void 0 ? void 0 : cohortedResultExprs.length) {
                cohortedResultExprs.forEach((expr) => pushSelect(expr, (0, measuresAsColumns_1.isSummableMeasure)(column)));
            }
        }
        else if (column.columnType &&
            [
                columnTypes_1.ColumnTypes.AppMeasureV2,
                columnTypes_1.ColumnTypes.AppMeasureCPAV2,
                columnTypes_1.ColumnTypes.AppMeasureSumV2,
                columnTypes_1.ColumnTypes.AppMeasure,
                columnTypes_1.ColumnTypes.AppMeasureCPA,
                columnTypes_1.ColumnTypes.DimensionAsMeasure,
                columnTypes_1.ColumnTypes.DimensionAsMeasureCPA,
                columnTypes_1.ColumnTypes.DimensionAsMeasurePCPA,
            ].includes(column.columnType)) {
            pushSelect(customMeasureToQueryExpr(column, onException), (0, measuresAsColumns_1.isSummableMeasure)(column));
        }
        else {
            let expr = measureToQueryExpr(roasEventsInCampaign, roasEventsInCampaignsMap, isMultiCampaign)(column);
            if (!expr) {
                // sometimes orderedColumns of stored reports contain outdated columns that doesn't have query expr anymore
                expr = query_1.DUMMY_EXPRESSION;
            }
            pushSelect(expr, (0, measuresAsColumns_1.isSummableMeasure)(column));
        }
    }
    return { selectExps, valueAliases: [...valueAliases] };
};
const getQuery = ({ start, finish, filterBy, splits = [], granularity = "ALL", orderedColumns, hasLimit = true, hiddenColumns, 
//campaign-specific
campaignId, roasEventsInCampaign, //expected for single campaign report only
roasEventsInCampaignsMap, //expected for multiple campaigns report only
isMultiCampaign, }) => {
    const groupBy = splits
        .map((split) => split.id)
        .filter((s) => s !== dbTableCampaign_1.DimensionIds.GRANULARITY_COLUMN_ID);
    const where = [
        (0, query_1.TIME_RANGE_EXPR)(start, finish),
        ...(filterBy ? (0, queryMapping_1.FILTERS_QUERY_MAP)(filterBy) : []),
    ];
    if (campaignId) {
        where.push({ $eq: ["CAMPAIGN_ID", campaignId] });
    }
    //rows where every summable measure is 0 are just noise, drop them in the query itself
    //so they don't eat up the rows limit. Not for the unsplit query: that one is the totals row
    const hasSplitRows = splits.length > 0;
    const { selectExps: select, valueAliases } = getMeasuresSelectQuery({
        orderedColumns,
        roasEventsInCampaign,
        roasEventsInCampaignsMap,
        isMultiCampaign,
        hiddenColumns,
        withValueAliases: hasSplitRows,
    });
    const finalQuery = {
        from: dbSchema_1.ReporterTables.Campaign,
        granularity: queryMapping_1.ANALYTICS_QUERY_MAP.granularity(granularity),
        groupBy: [...groupBy],
        select,
        where,
    };
    if (hasSplitRows && valueAliases.length) {
        finalQuery.having = [
            { $or: valueAliases.map((alias) => ({ $ne: [alias, 0] })) },
        ];
    }
    if (hasLimit) {
        finalQuery.limit = exports.ANALYTICS_REPORT_ROWS_LIMIT + 1; //to know if it is over limit on getting response
    }
    finalQuery.orderBy = splits.map((gr) => {
        if (gr.id === dbTableCampaign_1.DimensionIds.GRANULARITY_COLUMN_ID) {
            return {
                expr: "DATETIME",
                direction: "DESC",
            };
        }
        return {
            expr: gr.id,
            direction: "DESC",
        };
    });
    return finalQuery;
};
exports.getQuery = getQuery;
